import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${p => p.bg || '#000'};
  padding: 60px 24px;
`;

export const Container = styled.div`
  max-width: 860px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  color: ${p => p.color || '#fff'};
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 32px;
`;

export const Section = styled.section`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h2`
  color: ${p => p.accent || '#667eea'};
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const Text = styled.p`
  color: ${p => p.color || '#fff'}cc;
  font-size: 15px;
  line-height: 1.7;
`;

export const StepGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
`;

export const StepCard = styled.div`
  background: ${p => p.accent || '#667eea'}12;
  border: 1px solid ${p => p.accent || '#667eea'}33;
  border-radius: 12px;
  padding: 20px 16px;

  .num {
    width: 32px; height: 32px;
    border-radius: 50%;
    background: ${p => p.accent || '#667eea'};
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  h3 {
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  p {
    color: #ffffffaa;
    font-size: 13px;
    line-height: 1.5;
  }
`;
